
  <div class="row mt-5">
    @if(loading){
    <div class="col-12 text-center">
      <span class="largefont">{{sMensaje}} <i class="fa fa-spinner fa-spin"></i></span>
    </div>
    }
    @if(failed){
    <div class="col-12 text-center">
      <span class="largefont">{{sMensajeError}} <i class="fas fa-exclamation-triangle"></i></span>
    </div>
    }
  </div>